import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router';

import SuspenseLoader from 'src/components/SuspenseLoader';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

const AIS140 = Loader(lazy(() => import('src/content/dashboards/AIS140')));
const FitmentRecords = Loader(
  lazy(() => import('src/content/management/FitmentRecords/View'))
);
const VehicleStatusDashboard = Loader(
  lazy(() => import('src/content/dashboards/sdDashboard'))
);
const Activation = Loader(
  lazy(() => import('src/content/root/Activation/View'))
);
const AddActivation = Loader(
  lazy(() => import('src/content/root/Activation/Form'))
);

// const TermsOfUse = Loader(lazy(() => import('src/TermsOfUse')));
// const PrivacyPage = Loader(lazy(() => import('src/PrivacyPage')));

const dashboardsRoutes = [
  {
    path: '/',
    element: <Navigate to="/vehicle-status" />
  },
  {
    path: '/dashboard',
    element: <AIS140 />
  },
  {
    path: '/fitmentRecords',
    element: <FitmentRecords />
  },
  {
    path: '/vehicle-status',
    element: <VehicleStatusDashboard />
  },
  // {
  //   path: '/term-of-use',
  //   element: <TermsOfUse />
  // },
  // {
  //   path: '/privacy',
  //   element: <PrivacyPage />
  // },
  {
    path: '/fitment',
    element: <Activation />
  },
  {
    path: '/fitment/add',
    element: <AddActivation />
  }
];

export default dashboardsRoutes;
